import { render } from "./OurClients.vue?vue&type=template&id=7736c310"
import script from "./OurClients.vue?vue&type=script&lang=js"
export * from "./OurClients.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__